<template>
  <div class="Team" :class="showRebeta ? 'on' : ''">
    <banner :groupInfo="groupInfo"></banner>
    <div class="Tc content">
      <!-- 团队信息 -->
      <div class="teamInfo">
        <div class="title">团队信息</div>
        <div class="head">
          <span>
            <img :src="groupInfo.wechat_avatar" />
          </span>
          <i> 团长 </i>
          <p>
            {{ groupInfo.wechat_nickname }}
          </p>
        </div>
        <div class="teammates">
          <div
            class="teammateslist"
            v-for="(item, i) in personGroupInfo"
            :key="i"
          >
            <div class="box">
              <img :src="item.wechat_avatar" />
            </div>
            <p>{{ item.wechat_nickname }}</p>
          </div>
          <div
            class="teammateslist"
            v-for="item in 4 - personGroupInfo.length"
            :key="item.uid"
          >
            <div class="invite" @click="getActivityStatus">
              <i>邀请入队</i>
              <img src="@/assets/invite.png" />
            </div>
          </div>
        </div>
      </div>
      <!-- 活动奖励 -->
      <div class="ActivitiesReward">
        <div class="title">活动奖励</div>
        <p>最高千元奖励，11月30日活动结束后记得回来领取噢~</p>
        <process :groupInfo="groupInfo"></process>
        <div class="btn" v-if="receiveState" @click="RebetaBtn">领取返利</div>
        <div class="btn" v-else @click="RebetaBtn">查看返利</div>
      </div>
      <!-- 活动规则 -->
      <rule></rule>
    </div>
    <rebeta
      :receiveState="receiveState"
      v-if="showRebeta"
      @hideRebeta="hideRebeta"
    ></rebeta>
    <wechat></wechat>
    <share :showShare="showShare" @hideShare="hideShare"></share>
    <div class="joinLink" v-if="joinLink">
      <div class="jl">
        <div class="close" @click="hidejoinLink()">
          <img src="@/assets/close.png" />
        </div>
        {{ shareData.link }}
      </div>
    </div>
  </div>
</template>

<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import Clipboard from "clipboard";
import banner from "./components/banner.vue";
import Rebeta from "./components/rebeta.vue";
import Rule from "./components/rule.vue";
import Share from "./components/share.vue";
import Wechat from "./components/wechat.vue";
import Process from "./components/process.vue";
export default {
  components: { banner, Rule, Rebeta, Wechat, Share, Process },
  name: "Team",
  data: function () {
    return {
      showRebeta: false,
      groupInfo: [],
      teamGroupInfo: [],
      personGroupInfo: [],
      // 领取礼包状态
      receiveState: false,
      showShare: false,
      joinLink: false,
      shareData: {
        title: "参与活动充值得返利",
        link:
          "https://m.rastargame.com/rebate/join/" + this.$route.params.teamID,
        imgUrl: "https://m.rastargame.com/rebateSharImg/share.jpg",
        desc: "我正在参与返利活动，快来看看吧~",
      },
    };
  },
  methods: {
    hidejoinLink() {
      this.joinLink = false;
    },
    // 邀请入队
    Join(val) {
      // this.showShare = val;
      new Promise((resolve, reject) => {
        let data = {
          tm: Date.parse(new Date()),
          con_id: this.$xh.xhParams.con_id,
          version: this.$xh.xhParams.version,
          nonce: this.$xh.nonce(),
        };
        data.sign = this.$RSSign(data, this.$xh.xhParams.key);
        this.$ajax({
          method: "get",
          url: this.$api.getWechat,
          params: {
            redirect_url: window.location.href,
          },
        })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      }).then((data) => {
        let wxData = data;
        wxData.jsApiList = [
          // "updateAppMessageShareData",
          // "updateTimelineShareData",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
        ];
        wx.config({
          debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
          appId: wxData.appId, // 必填，公众号的唯一标识
          timestamp: wxData.timestamp, // 必填，生成签名的时间戳
          nonceStr: wxData.nonceStr, // 必填，生成签名的随机串
          signature: wxData.signature, // 必填，签名
          jsApiList: wxData.jsApiList, // 必填，需要使用的 JS 接口列表
        });
        wx.ready(() => {
          wx.onMenuShareTimeline({
            title: this.shareData.title,
            link: this.shareData.link,
            imgUrl: this.shareData.imgUrl,
            success: function () {
              // 分享到朋友圈 用户确认分享后执行的回调函数
              console.log("ok");
            },
            fail: function (res) {
              console.log("分享到朋友圈==", JSON.stringify(res));
            },
          });
          wx.onMenuShareAppMessage({
            title: this.shareData.title,
            link: this.shareData.link,
            imgUrl: this.shareData.imgUrl,
            desc: this.shareData.desc,
            success: function () {
              // 分享给朋友 用户确认分享后执行的回调函数
              console.log("ok");
            },
            fail: function (res) {
              console.log("分享给朋友==", JSON.stringify(res));
            },
          });
          // wx.updateAppMessageShareData({
          //   title: this.shareData.title,
          //   link: this.shareData.link,
          //   imgUrl: this.shareData.imgUrl,
          //   desc: this.shareData.desc,
          //   success: function () {
          //     // 用户确认分享后执行的回调函数
          //     alert("ok");
          //   },
          //   fail: function (res) {
          //     console.log("分享给朋友==", JSON.stringify(res));
          //   },
          // });
          // wx.updateTimelineShareData({
          //   title: this.shareData.title,
          //   link: this.shareData.link,
          //   imgUrl: this.shareData.imgUrl,
          //   success: function () {
          //     // 用户确认分享后执行的回调函数
          //     alert("ok");
          //   },
          //   fail: function (res) {
          //     console.log("分享到朋友圈==", JSON.stringify(res));
          //   },
          // });
        });
        wx.error((err) => {
          console.log(err);
        });
      });
    },
    // 关闭分享
    hideShare() {
      this.showShare = false;
    },
    // 关闭返利弹窗
    hideRebeta() {
      console.log("关闭返利弹窗");
      this.showRebeta = false;
    },
    // 点击领取返利
    RebetaBtn() {
      console.log("点击领取返利");
      this.showRebeta = true;
    },
    // 获取团队信息接口
    getGroupInfo() {
      let data = {
        tm: Date.parse(new Date()),
        group_id: "rebate:" + this.$route.params.teamID,
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getGroupInfo,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            console.log("sss===", res.data.data);
            this.groupInfo = res.data.data;
            this.groupInfo.wechat_nickname = unescape(
              res.data.data.wechat_nickname
            );
          } else if (res.data.code == 6001) {
            // 队伍不存在
            this.$router.push({
              name: "Err",
            });
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取用户团队信息接口
    getUserGroupInfo() {
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getUserGroupInfo,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            var _this = this;
            res.data.data.forEach((item) => {
              // role_type 1 是团长
              if (item.role_type == 1) {
                _this.teamGroupInfo = item;
              }
              // role_type 1 是 团员
              if (item.role_type == 0) {
                _this.personGroupInfo.push(item);
              }
            });
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 活动状态 开始/结束
    getActivityStatus() {
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getActivityStatus,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.flag == true) {
              // 活动开启
              this.joinUrl();
              // this.Join(true);
              // this.getGroupStatus(1);
            } else {
              // console.log("活动尚未开始");
              this.$toast(res.data.msg);
            }
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 复制到剪贴板
    joinUrl() {
      var _this = this;
      let clipboard = new Clipboard(".invite", {
        text: function () {
          return (
            "https://m.rastargame.com/rebate/join/" + _this.$route.params.teamID
          );
        },
      });
      clipboard.on("success", (e) => {
        this.$toast("复制邀请链接成功，快去邀请小伙伴来加入队伍吧!");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$toast("复制失败, 请手动复制!");
        this.joinLink = true;
        clipboard.destroy();
      });
    },

    // 领取状态
    getReward() {
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getReward,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            if (res.data.data.flag == true) {
              // 领取开启
              this.receiveState = true;
            } else {
              console.log("活动尚未开始");
            }
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    if (this.$xh.isWeChat()) {
      if (this.$xh.getCookie("_XH_COMMON_WECHAT")) {
        this.$xh.setCookie(
          "_XH_REBATE_NICKNAME",
          JSON.parse(unescape(this.$xh.getCookie("_XH_COMMON_WECHAT")))
            .nickname,
          30,
          window.location.hostname
        );
        this.$xh.setCookie(
          "_XH_REBATE_HEADIMGURL",
          JSON.parse(unescape(this.$xh.getCookie("_XH_COMMON_WECHAT")))
            .headimgurl,
          30,
          window.location.hostname
        );
      }
      // 判断页面是否是第一次访问，默认是
      if (!this.$xh.getCookie("firstVisit")) {
        this.$xh.setCookie("firstVisit", "true", 30, window.location.hostname);
      }
      let wxName = this.$xh.getCookie("_XH_REBATE_NICKNAME");
      let wxImg = this.$xh.getCookie("_XH_REBATE_HEADIMGURL");
      if (this.$xh.getCookie("firstVisit") == "true") {
        console.log("玩家第一次进入页面");
        if (!wxName && !wxImg) {
          // 跳微信授权
          console.log("跳微信授权");
          window.location.href =
            "https://pt-u.rastargame.com/common/WechatCommon/oauth/?type=wechat&redirect_url=" +
            window.location.href;
        }
        this.$xh.setCookie("firstVisit", "false", 30, window.location.hostname);
      } else {
        let userCookie = this.$xh.getCookieArray("_XH_U_CL");
        if (userCookie[0]) {
          console.log("已登陆逻辑");
          this.getUserGroupInfo();
          this.getGroupInfo();
          this.getReward();
        } else {
          window.location.href =
            "https://m.rastargame.com/dist/login?type=1&return=" +
            encodeURIComponent(window.location.href);
        }
      }
      this.Join(false);
    }
  },
};
</script>
  
<style scoped lang="scss" src="@/sass/team.scss">
</style>